/**
 * Adaptateur - SecurgenCardReaderAdapter
 *
 * Mock du lecteur de carte Securgen
 * Note: Utilisez RealSecurgenCardReaderAdapter pour la vraie intégration
 */

import { ICardReaderService, CardReadResult } from '../../application/ports/output/ICardReaderService';

export class SecurgenCardReaderAdapter implements ICardReaderService {
  private cardPresent = false;

  /**
   * Attend l'insertion d'une carte
   */
  async waitForCardInsertion(_timeoutMs = 30000): Promise<CardReadResult> {
    console.warn('[SecurgenCardReaderAdapter] Mock adapter - use RealSecurgenCardReaderAdapter for production');
    return {
      success: false,
      errorCode: 'MOCK_ADAPTER_NOT_SUPPORTED',
    };
  }

  /**
   * Éjecte la carte
   */
  async ejectCard(): Promise<void> {
    console.warn('[SecurgenCardReaderAdapter] Mock adapter - use RealSecurgenCardReaderAdapter for production');
    this.cardPresent = false;
  }

  /**
   * Vérifie si une carte est présente
   */
  isCardPresent(): boolean {
    return this.cardPresent;
  }

  /**
   * Vérifie si le lecteur est disponible
   */
  async isAvailable(): Promise<boolean> {
    console.warn('[SecurgenCardReaderAdapter] Mock adapter - use RealSecurgenCardReaderAdapter for production');
    return false;
  }
}
